import { format, isEqual, parse } from 'date-fns';

export function validateFormField(field, _, originalArray) {
  field.isVariableNameRepeated = originalArray.some(
    (fieldItem) =>
      (fieldItem.id ? fieldItem.id !== field.id : fieldItem._temp_id !== field._temp_id) &&
      fieldItem.var_name === field.var_name
  );
  let isRadioOrSelectInValid = false;

  if (['radio', 'multiselect'].includes(field.type)) {
    const options = field.settings.options ?? [];
    const hasSomeInvalidOption = options.some(({ label, value }, i) => {
      const isRepeatedValue = options.some((option, idx) => idx !== i && option.value === value);
      return !label || !value || isRepeatedValue;
    });
    const defaultSelectedSetting = field.settings.default_selected;
    const isDefaultSelectedNotAnAvailableOption =
      Boolean(defaultSelectedSetting) && !options.some(({ value }) => value === defaultSelectedSetting);

    isRadioOrSelectInValid = !options.length || hasSomeInvalidOption || isDefaultSelectedNotAnAvailableOption;
  }

  field.isValid = !field.isVariableNameRepeated && !isRadioOrSelectInValid;

  if (field.type === 'date') {
    field.isValid = field.isValid && field.isDateFormatValid;
  }

  return field;
}

export function getDateFormatValidation(dateFormat) {
  let isValid = false;
  try {
    const date = new Date('2021-09-01 00:00:00'); // A hardcoded date for consistency in the validation process, since the date-fns parse function uses the current date as a reference.
    const REFERENCED_DATE = new Date();
    const formattedDate = format(date, dateFormat);
    const parsedDate = parse(formattedDate, dateFormat, REFERENCED_DATE);
    isValid = isEqual(date, parsedDate);
  } catch (error) {
    console.error(error);
  }

  return isValid;
}
